export default "__VITE_ASSET__Df2kA604__"